// eovii 3+1: adds the picked free Ballerina pair to the cart, then re-renders the cart drawer.
// Uses event delegation because the drawer HTML is replaced on every cart change.
document.addEventListener("click", async (event) => {
  const button = event.target.closest("[data-ev-gift-add]");
  if (!button || button.disabled) return;
  event.preventDefault();

  const box = button.closest("[data-ev-fp]");
  const picked = box && box.querySelector('input[name="ev-gift"]:checked');
  const error = box && box.querySelector("[data-ev-gift-error]");
  if (!picked) return;

  button.disabled = true;
  if (error) error.hidden = true;

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(picked.value), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error(`cart/add failed: ${response.status}`);

    document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
  } catch (e) {
    console.error(e);
    button.disabled = false;
    if (error) error.hidden = false;
  }
});

// Express checkout buttons: 1 wallet on mobile (Apple Pay, else PayPal),
// 2 on desktop (Apple Pay or Google Pay, plus PayPal).
// Shopify renders one button per entry in `wallet-configs` inside a closed shadow root, so hiding
// buttons with CSS leaves empty slots. The buttons are shipped in a <template> and the list is
// trimmed before the element is inserted, so Shopify only renders the wanted ones.
const EV_WALLET_TAGS = {
  shop_pay: "shop-pay-wallet-button",
  paypal: "shopify-paypal-button",
  google_pay: "shopify-google-pay-button",
  apple_pay: "shopify-apple-pay-button",
};

function evPickWallets(available) {
  const hasApple = available.includes("apple_pay") && "ApplePaySession" in window;
  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  const wanted = isMobile
    ? [hasApple ? "apple_pay" : "paypal"]
    : [hasApple ? "apple_pay" : "google_pay", "paypal"];
  const picked = wanted.filter((name) => available.includes(name));
  return picked.length ? picked : available.slice(0, isMobile ? 1 : 2);
}

function evMountExpressCheckout() {
  document.querySelectorAll("template[data-ev-xco]").forEach((template) => {
    const target = template.nextElementSibling;
    if (!target || !target.hasAttribute("data-ev-xco-target") || target.childElementCount) return;

    const content = template.content.cloneNode(true);
    const wallets = content.querySelector("shopify-accelerated-checkout-cart");
    if (wallets) {
      try {
        const configs = JSON.parse(wallets.getAttribute("wallet-configs") || "[]");
        const keep = evPickWallets(configs.map((c) => c.name));
        wallets.setAttribute("wallet-configs", JSON.stringify(configs.filter((c) => keep.includes(c.name))));
        const keepTags = keep.map((name) => EV_WALLET_TAGS[name]);
        [...wallets.children].forEach((child) => {
          const tag = child.tagName.toLowerCase();
          if (Object.values(EV_WALLET_TAGS).includes(tag) && !keepTags.includes(tag)) child.remove();
        });
      } catch (e) {
        console.error(e);
      }
    }
    target.appendChild(content);
  });
}

evMountExpressCheckout();
new MutationObserver(evMountExpressCheckout).observe(document.documentElement, { childList: true, subtree: true });
